import React, { FC } from 'react';
import { Path } from './styles';

const Drink: FC<SVGIconProps> = ({ color }) => (
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none">
    <Path
      d="M19.6875 18.375L14.4375 13.125H48.5625L43.3125 18.375M28.875 34.125V49.875H15.75V55.125H47.25V49.875H34.125V34.125L55.125 13.125V7.875H7.875V13.125L28.875 34.125Z"
      fillColor={color}
    />
  </svg>
);

export default Drink;
